var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartjs-wrapper',{ref:"chartJsWrapper",staticClass:"white",attrs:{"chartId":"priceHistoryChart","chart-data":_vm.priceHistoryChartData,"type":'line',"options":_vm.priceHistoryChartOptions,"chart-height":30,"hover-line":""}})}
var staticRenderFns = []

export { render, staticRenderFns }